import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';
import { useRouter } from 'next/router';
import { BreadcrumbJsonLd } from 'next-seo';

import BreadCrumbs from '../breadcrumbs/breadcrumb';
import CallbackModal from '../callback-modal/requestcallback-modal';
import StorageWorks from '../portable-storage/moving/how-storage-works';
import Pricing from '../portable-storage/moving/price/pricing';
import { generateDynamicBCLD } from '../utility';
import ProjectOrg from './project-org';

const PortableBusinessComponent = (props: any) => {
  const router = useRouter();
  const pathWithoutQuery = router.asPath.split('?')[0];
  const title = props?.portResData?.attributes?.Section[0]?.Title;
  const subTitle = props?.portResData?.attributes?.Section[0]?.Sub_Title;
  const howWorksTitle = props?.portResData?.attributes?.Section[1]?.Title;
  const howWorksData = props?.portResData?.attributes?.Section[2]?.Cards;
  const projectTitle = props?.portResData?.attributes?.Section[3]?.Title;
  const projectDesc = props?.portResData?.attributes?.Section[3]?.Description;
  const projectData = props?.portResData?.attributes?.Section[4];

  const priceValue = props?.priceValue;

  const priceTitle = props?.portResData?.attributes?.Section[5]?.Title;
  const priceData = props?.portResData?.attributes?.Section[6];
  const breadCrumbUrlList = generateDynamicBCLD(router);
  return (
    <div className="sv-page-content sv-ps-business-wrapper">
      <div className="container-xl custom-container px-0">
        <section className="hero-section">
          <div className="hero-banner ps-business-banner">
            <Image
              sizes="(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1280px"
              src={
                props?.portResData?.attributes?.Section[0]?.Background_Image
                  ?.data.attributes?.url
              }
              alt={
                props?.portResData?.attributes?.Section[0]?.Background_Image
                  ?.data.attributes?.alternativeText ||
                props?.portResData?.attributes?.Section[0]?.Background_Image
                  ?.data.attributes?.name
              }
              className="banner-img"
              width="1280"
              height="516"
            />

            <div className="banner-content">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 m-auto">
                    <h1>{title}</h1>
                    <h6
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(subTitle),
                      }}
                    ></h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="my-4">
        <BreadCrumbs path={pathWithoutQuery} />
        <BreadcrumbJsonLd itemListElements={breadCrumbUrlList} />
      </div>
      <StorageWorks howWorksTitle={howWorksTitle} howWorksData={howWorksData} />
      <ProjectOrg
        projectTitle={projectTitle}
        projectDesc={projectDesc}
        projectData={projectData}
      ></ProjectOrg>
      <Pricing
        priceTitle={priceTitle}
        priceData={priceData}
        priceValue={priceValue}
      ></Pricing>
      <CallbackModal
        unitRate={priceValue}
        storeType="ps"
        formType=""
      ></CallbackModal>
    </div>
  );
};

export default PortableBusinessComponent;
